import {
  FETCH_PROJECT_CUSTOM_FIELD_STARTED,
  FETCH_PROJECT_CUSTOM_FIELD_SUCCEEDED,
  FETCH_PROJECT_CUSTOM_FIELD_FAILED,
  FETCH_PROJECT_CUSTOM_FIELD_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  customFields: [],
  status: statuses.idle
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_PROJECT_CUSTOM_FIELD_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case FETCH_PROJECT_CUSTOM_FIELD_SUCCEEDED:
      return {
        ...state,
        customFields: action.payload,
        status: statuses.succeeded
      };
    case FETCH_PROJECT_CUSTOM_FIELD_FAILED:
      return { ...state, status: statuses.failed, customFields: [], error: action.error };
    case FETCH_PROJECT_CUSTOM_FIELD_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
